import form from './form';
import index from './index';
import { Router } from '@/legacy/Router';

Router.get('judging/copy-panel/:any', form);
Router.get('judging/panel/:any', form);
Router.get('judging/panel', index);
